import {
    httpStoreTeamByProject,
    httpStoreTeamByTreatmentRequest,
    HttpStoreTeamPayload
} from '@/features/treatment-requests/teams/http/teams.http'
import {MUTATION_KEYS} from '@/queryClient'
import {ErrorResponseData} from '@/types'
import {useMutation, UseMutationOptions} from '@tanstack/react-query'
import {AxiosError} from 'axios'
import {TeamMember} from '@/features/treatment-requests/teams/types'

export type UseStoreTeamSource = {treatmentRequestId: string} | {projectId: string}

export const useStoreTeam = (
    source: UseStoreTeamSource,
    options?: UseMutationOptions<TeamMember[], AxiosError<ErrorResponseData>, HttpStoreTeamPayload>
) => {
    return useMutation({
        ...options,
        mutationKey: [MUTATION_KEYS.STORE_TEAM, source],
        mutationFn: (payload: HttpStoreTeamPayload) =>
            'treatmentRequestId' in source
                ? httpStoreTeamByTreatmentRequest({
                      urlParams: {treatmentRequestId: source.treatmentRequestId},
                      payload
                  })
                : httpStoreTeamByProject({urlParams: {projectId: source.projectId}, payload})
    })
}
